import { render, staticRenderFns } from "./Tendency_singoHolter.vue?vue&type=template&id=23e6415e&scoped=true"
import script from "./Tendency_singoHolter.vue?vue&type=script&lang=js"
export * from "./Tendency_singoHolter.vue?vue&type=script&lang=js"
import style0 from "./Tendency_singoHolter.vue?vue&type=style&index=0&id=23e6415e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e6415e",
  null
  
)

export default component.exports